/**
 * Created by mzhao on 09/28/2021.
 * Description:
 * ExchangeDialogOptions model
 * ------ maintenance history ------
 */

import { ExchangeImportDataModel } from '../../../tamalelibs/models/exchange-import.model';


export class ExchangeListDialogOptions {
    minimize: boolean;
    instanceId = '';
    searchValue: string;
    isReOpen = false;
    data: ExchangeImportDataModel;
}

